import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOtherChargesQuickInfo extends Layout {
	sourceOrderOtherCharge: DataSource;
	tableOtherCharge: Table;
}
